// extracted by mini-css-extract-plugin
export default {"container":"switch_container__ixqcv","dark":"switch_dark__Y4vDW"};